import React         from 'react';
import { Component } from 'react';
import { connect }   from 'react-redux';
import { Routes as RRRoutes }    from 'react-router-dom';
import { Route }     from 'react-router-dom';
import { NavLink }   from 'react-router-dom';
import { Navigate }  from 'react-router-dom';

//Import documentation
import Device from './device';

//css
import './index.scss';

//routing constants
import * as Routes from 'dev/docs/doc-routes';


class Tools extends Component {
    render() {
        
        return (
            <div className="tools-wrapper">
                <div className="menu-wrapper">
                    <NavLink to = { Routes.device } exact activeClassName='active' className="docs-item">deviceState</NavLink>
                </div>
                <RRRoutes>
                    <Route exact path= { Routes.tools }>
                        <Navigate to={ Routes.device } />
                    </Route>
                    <Route exact path={ Routes.device } element={ <Device/> }/>
                </RRRoutes>
            </div>
        )
    }
}

//get required state from redux store and map them to the components props
const mapStateToProps = store => {
    return {
        deviceState: store.deviceState,
    }
}
export default connect(mapStateToProps, null, null)(Tools);
